import IndexPage from '@/pages/index.vue';
import DashboardPersonal from '@/pages/dashboardPersonal.vue';
import pendingTasks from '@/pages/pendingTasks.vue';
import LoginPage from '@/pages/LoginPage.vue';
import PermissionDeniedPage from '@/pages/PermissionDeniedPage.vue';
import SelectRoles from '@/pages/SelectRoles.vue';
import AdminPage from '@/pages/admin/AdminPage.vue';
import ListWorkflows from '@/pages/admin/workflows/List.vue';
import WelcomePage from '@/pages/admin/WelcomePage.vue';
import AccountPage from '@/pages/AccountPage.vue';
import CreateWorkflow from '@/pages/admin/workflows/Create.vue';

// Usuarios
import AdminUsersPage from '@/pages/admin/users/Index.vue';

// Areas
import AdminAreasPage from '@/pages/admin/areas/Index.vue';

// Empresas
import AdminCompaniesPage from '@/pages/admin/companies/List.vue';

// Contratos
import AdminContractsPage from '@/pages/admin/contracts/List.vue';
import ContractCreateStep1 from '@/pages/admin/contracts/create/Step1.vue';
import ContractCreateStep2 from '@/pages/admin/contracts/create/Step2.vue';
import ContractCreateStep3 from '@/pages/admin/contracts/create/Step3.vue';

// Inventarios
import InventorySelectPage from '@/pages/inventories/Select.vue';
import InventoryShowPage from '@/pages/inventories/Show.vue';
import InventoryEditPage from '@/pages/inventories/Edit.vue';
import InventoryCheckPage from '@/pages/inventories/Check.vue';

import InventoryEditTaskStep1 from '@/pages/inventories/tasks/Step1.vue';
import InventoryEditTaskStep2 from '@/pages/inventories/tasks/Step2.vue';
import InventoryEditTaskStep3 from '@/pages/inventories/tasks/Step3-Summary.vue';

// Riesgos Estandarizados
import RisksList from '@/pages/risks/List.vue';

import pushIndex from '@/pages/pushIndex.vue';

// i18n
import { Trans } from '@/helpers/i18n';
import RouterWrapper from '@/pages/RouterWrapper.vue';

//
import procedure from '@/pages/admin/Procedure.vue';

// procedures
import crearRiesgoBowtie from '@/procedures/crearRiesgoBowtie.vue';
import UpdateContractRoles from '@/pages/admin/UpdateContractRoles.vue';

export default [
  {
    path: '/:lang',
    name: 'languageRoute',
    component: RouterWrapper,
    beforeEnter: Trans.routeMiddleware,
    children: [
      {
        path: 'procedure',
        name: 'procedure',
        component: AdminPage,
        meta: {
          layout: 'procedure',
        },
        children: [
          {
            path: 'crearRiesgoBowtie',
            name: 'crearRiesgoBowtie',
            component: crearRiesgoBowtie,
            meta: {
              layout: 'procedure',
            },
          },
        ],
      },
      {
        path: 'procedures',
        name: 'procedures',
        component: procedure,
      },
      {
        path: 'pushIndex',
        name: 'pushIndex',
        component: pushIndex,
      },
      {
        path: '',
        name: 'homePage',
        component: IndexPage,
        meta: {
          layout: "login"
        }
      },
      {
        path: 'dashboard-personal',
        name: 'dashboardPersonal',
        component: DashboardPersonal
      },
      {
        path: 'pending-tasks',
        name: 'tareasPendientes',
        component: pendingTasks
      },
      {
        path: 'permiso-denegado',
        name: 'permisoDenegado',
        component: PermissionDeniedPage,
        meta: {
          layout: 'blank',
        },
      },
      {
        path: 'login',
        name: 'login',
        component: LoginPage,
        meta: {
          layout: 'login',
        },
      },
      {
        path: 'admin',
        name: 'admin',
        component: AdminPage,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: 'welcome',
            name: 'welcome',
            component: WelcomePage,
          },
          {
            path: 'usuarios',
            name: 'usuarios',
            component: AdminUsersPage,
          },
          {
            path: 'empresas',
            name: 'empresas',
            component: AdminCompaniesPage,
          },
          {
            path: 'contratos/crear/paso1',
            name: 'contractCreateStep1',
            component: ContractCreateStep1,
          },
          {
            path: 'contratos/crear/paso2',
            name: 'contractCreateStep2',
            component: ContractCreateStep2,
          },
          {
            path: 'contratos/crear/paso3',
            name: 'contractCreateStep3',
            component: ContractCreateStep3,
          },
          {
            path: 'contratos',
            name: 'listContracts',
            component: AdminContractsPage,
          },
          {
            path: 'areas',
            name: 'areas',
            component: AdminAreasPage,
          },
          {
            path: 'UpdateContractRoles',
            name: 'UpdateContractRoles',
            component: UpdateContractRoles,
          },
          {
            path: 'workflow/create',
            name: 'createWorkflow',
            component: CreateWorkflow,
          },
        ],
      },
      {
        path: 'workflows',
        name: 'workflows',
        component: ListWorkflows,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'riesgos-estandarizados',
        name: 'standarized-risks',
        component: RisksList,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'inventario/tareas/paso1',
        name: 'firstStep',
        component: InventoryEditTaskStep1,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'inventario/tareas/paso2',
        name: 'secondStep',
        component: InventoryEditTaskStep2,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'inventario/tareas/step3',
        name: 'summaryStep',
        component: InventoryEditTaskStep3,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'mi-cuenta',
        name: 'cuenta',
        component: AccountPage,
        meta: {
          requiresAuth: true,
        },
      },
      // Multirroles
      {
        path: 'inventarios',
        name: 'inventorySelectPage',
        component: InventorySelectPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'seleccionar-roles',
        name: 'SelectRoles',
        component: SelectRoles,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'inventario/:contratoId/ver',
        name: 'inventoryShowPage',
        component: InventoryShowPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'inventario/:contratoId/editar',
        name: 'editInventoryPage',
        component: InventoryEditPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'inventario/:contratoId/revisar',
        name: 'checkInventoryPage',
        component: InventoryCheckPage,
        /* meta: {
          requiresAuth: true,
        }, */
      },
    ],
  },
  {
    path: '*',
    redirect: Trans.getTranslatedRoute,
  },
];
